import { makeStyles, tokens, Text, Title2 } from '@fluentui/react-components';

const useStyles = makeStyles({
  card: {
    background: tokens.colorNeutralBackground1,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRadius: '8px',
    padding: '16px 20px',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  label: { color: tokens.colorNeutralForeground3, fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.4px' },
  value: { fontSize: '28px', fontWeight: 600, color: tokens.colorNeutralForeground1 },
  hint: { color: tokens.colorNeutralForeground3, fontSize: '12px' },
});

export function MetricCard(props: { label: string; value: string; hint?: string }) {
  const s = useStyles();
  return (
    <div className={s.card}>
      <span className={s.label}>{props.label}</span>
      <Title2 as="h2" className={s.value}>{props.value}</Title2>
      {props.hint ? <Text className={s.hint}>{props.hint}</Text> : null}
    </div>
  );
}
